import React from 'react'

import { AuthProvider } from './auth'
import { ToastProvider } from './toast'
import { AlertProvider } from '../services/alertService'

const AppProvider: React.FC = ({ children }) => (
  <AuthProvider>
    <ToastProvider>
      <AlertProvider>{children}</AlertProvider>
    </ToastProvider>
  </AuthProvider>
)

export default AppProvider
